<template>
  <div class="container">
    <div class="row justify-content-md-center mt-3">
      <div class="col-md-24">
        <div class="card">
          <h5 class="card-header">
            Awaiting Pickup
          </h5>
          <div class="card-body">
            <div
              class="alert alert-light mb-0"
              v-if="
                loadingAwaitingPickupBookings ||
                  awaitingPickupBookings.data.length == 0
              "
            >
              <span v-if="loadingAwaitingPickupBookings">
                <loading-alert text="Fetching bookings"></loading-alert>
              </span>
              <span v-else>No bookings to show.</span>
            </div>

            <div v-else>
              <pagination
                :data="awaitingPickupBookings"
                v-on:pagination-change-page="fetchAwaitingPickupBookings"
                :limit="10"
              ></pagination>
              <table
                class="table table-hover table-bordered"
                style="font-size:0.9rem"
              >
                <thead>
                  <th style="width:120px">Booking</th>
                  <th>Pickup</th>
                  <th>Deliver</th>
                  <th>Freight</th>
                  <th style="width:140px">Details</th>
                  <th style="width:124px">Downloads</th>
                </thead>
                <tbody>
                  <booking-item
                    v-for="booking in awaitingPickupBookings.data"
                    :key="booking.id"
                    :booking="booking"
                    :selected="booking.id == selected"
                    :pickedUpChecked="booking.id == selectedBooking"
                    @showConfirmModal="showConfirmModal(booking.id)"
                    :user="user"
                  >
                  </booking-item>
                </tbody>
              </table>
              <pagination
                :data="awaitingPickupBookings"
                v-on:pagination-change-page="fetchAwaitingPickupBookings"
                :limit="10"
              ></pagination>
            </div>
          </div>
        </div>

        <div class="card mt-3">
          <h5 class="card-header">
            Out for delivery
          </h5>
          <div class="card-body">
            <div
              class="alert alert-light mb-0"
              v-if="
                loadingAwaitingDeliveryBookings ||
                  awaitingDeliveryBookings.data.length < 1
              "
            >
              <span v-if="loadingAwaitingDeliveryBookings">
                <loading-alert text="Fetching bookings"></loading-alert>
              </span>
              <span v-else>No bookings to show.</span>
            </div>

            <div v-else>
              <pagination
                :data="awaitingDeliveryBookings"
                v-on:pagination-change-page="fetchAwaitingDeliveryBookings"
                :limit="10"
              ></pagination>
              <table
                class="table table-striped table-bordered"
                style="font-size:0.9rem"
              >
                <thead>
                  <th style="width:120px">Booking</th>
                  <th>Pickup</th>
                  <th>Deliver</th>
                  <th>Freight</th>
                  <th style="width:140px">Details</th>
                  <th style="width:124px">Downloads</th>
                </thead>
                <tbody>
                  <booking-item
                    v-for="booking in awaitingDeliveryBookings.data"
                    :key="booking.id"
                    :booking="booking"
                  >
                  </booking-item>
                </tbody>
              </table>
              <pagination
                :data="awaitingDeliveryBookings"
                v-on:pagination-change-page="fetchAwaitingDeliveryBookings"
                :limit="10"
              ></pagination>
            </div>
          </div>
        </div>

        <div class="card mt-3">
          <h5 class="card-header">
            Other Freighthub network bookings

            <div
              class="info d-inline"
              data-toggle="tooltip"
              data-placement="bottom"
              data-html="true"
              title=""
              data-original-title="
                            <h6>What are network bookings?</h6>
                            These are bookings made by other Freighthub customers that are
                            either being picked up from, or delivered to your business"
            >
              <i class="far fa-info-circle"></i>
            </div>
          </h5>
          <div class="card-body">
            <div
              class="alert alert-light mb-0"
              v-if="loadingNetworkBookings || networkBookings.length < 1"
            >
              <span v-if="loadingNetworkBookings">
                <loading-alert text="Fetching bookings"></loading-alert>
              </span>
              <span v-else>No bookings to show.</span>
            </div>

            <table
              class="table table-striped table-bordered"
              style="font-size:0.9rem"
              v-else
            >
              <thead>
                <th style="width:120px">Booking</th>
                <th>Pickup</th>
                <th>Deliver</th>
                <th>Freight</th>
                <th style="width:140px">Details</th>
                <th style="width:124px">Downloads</th>
              </thead>
              <tbody>
                <network-booking-item
                  v-for="booking in networkBookings"
                  :key="booking.id"
                  :booking="booking"
                >
                </network-booking-item>
              </tbody>
            </table>
          </div>
        </div>

        <confirm-modal
          v-if="modalShowing"
          :showing="modalShowing"
          :confirming="confirming"
          title="Confirm Pick up?"
          text="Are you sure you want to mark this booking as picked up?"
          @confirmed="confirmPickUp()"
          @cancelled="confirmPickUpCancelled()"
        >
        </confirm-modal>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingAlert from "../../../utils/LoadingAlert";
import ConfirmModal from "../../../utils/ConfirmModal";

import BookingItem from "./BookingItem";
import NetworkBookingItem from "./NetworkBookingItem";

export default {
  name: "current-bookings",
  components: { LoadingAlert, ConfirmModal, BookingItem, NetworkBookingItem },
  props: ["selected", "user"],
  data() {
    return {
      awaitingPickupBookings: {
        current_page: 1,
        data: [],
        from: 1,
        last_page: 1,
        next_page_url: null,
        per_page: 10,
        prev_page_url: null,
        to: 1,
        total: 0
      },
      awaitingDeliveryBookings: {
        current_page: 1,
        data: [],
        from: 1,
        last_page: 1,
        next_page_url: null,
        per_page: 10,
        prev_page_url: null,
        to: 1,
        total: 0
      },
      networkBookings: [],

      loadingAwaitingPickupBookings: null,
      loadingAwaitingDeliveryBookings: null,
      loadingNetworkBookings: null,

      modalShowing: false,
      confirming: false,
      selectedBooking: ""
    };
  },

  mounted() {
    this.loadAllBookings();
  },

  methods: {
    loadAllBookings() {
      this.fetchAwaitingPickupBookings();
      this.fetchAwaitingDeliveryBookings();
      this.fetchNetworkBookings();
    },

    fractalToPagination(fractal, pagination) {
      pagination.current_page = fractal.meta.pagination.current_page;
      pagination.data = fractal.data;
      pagination.last_page = fractal.meta.pagination.total_pages;
      pagination.next_page_url = fractal.meta.pagination.links.next;
      pagination.prev_page_url = fractal.meta.pagination.links.previous;
      pagination.per_page = fractal.meta.pagination.per_page;
      pagination.total = fractal.meta.pagination.total;
      pagination.from =
        (fractal.meta.pagination.current_page - 1) *
          fractal.meta.pagination.per_page +
        1;
      pagination.to =
        fractal.meta.pagination.current_page * fractal.meta.pagination.per_page;
    },

    fetchAwaitingPickupBookings(page) {
      this.loadingAwaitingPickupBookings = true;

      if (typeof page === "undefined") {
        page = 1;
      }

      axios
        .get("awaiting-pickup?page=" + page)
        .then(response => {
          this.loadingAwaitingPickupBookings = false;
          return response;
        })
        .then(data => {
          this.fractalToPagination(data.data, this.awaitingPickupBookings);
        })
        .catch(errors => {
          this.loadingAwaitingPickupBookings = false;
          Event.$emit("serverError");
        });
    },

    confirmPickUpCancelled() {
      this.selectedBooking = null;
      this.modalShowing = false;
    },

    fetchAwaitingDeliveryBookings(page) {
      this.loadingAwaitingDeliveryBookings = true;

      if (typeof page === "undefined") {
        page = 1;
      }

      axios
        .get("awaiting-delivery?page=" + page)
        .then(response => {
          this.loadingAwaitingDeliveryBookings = false;
          return response;
        })
        .then(data => {
          this.fractalToPagination(data.data, this.awaitingDeliveryBookings);
        })
        .catch(errors => {
          this.loadingAwaitingDeliveryBookings = false;
          Event.$emit("serverError");
        });
    },

    fetchNetworkBookings() {
      this.loadingNetworkBookings = true;

      axios
        .get("network-bookings")
        .then(response => {
          this.networkBookings = response.data.data;
          this.loadingNetworkBookings = false;
        })
        .catch(errors => {
          this.loadingNetworkBookings = false;
          Event.$emit("serverError");
        });
    },

    showConfirmModal(booking) {
      this.modalShowing = true;
      this.selectedBooking = booking;
    },

    confirmPickUp() {
      this.confirming = true;

      axios
        .patch(this.selectedBooking + "/pickups")
        .then(response => {
          this.loadAllBookings();
          this.confirming = false;
          this.modalShowing = false;
          this.$swal({
            title: "Booking marked as picked up!",
            type: "success",
            confirmButtonText: "Okay"
          });
        })
        .catch(errors => {
          this.confirming = false;
          this.modalShowing = false;
          Event.$emit("serverError");
        });
    }
  }
};
</script>
